import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { getTaskList, deleteTargetsDetail, disableTask, enableTask } from '@blade-sxp/monitor/api/monitor-management/task';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class default_1 extends Vue {
    multipleTable;
    keyword;
    librariesAll = [];
    multipleSelection = [];
    multipleLength = 0;
    currentPage4 = 4;
    loading = false;
    imgUrl = require('@blade/common/assets/images/user.png');
    taskList = [];
    pagination = {
        page: 1,
        size: 100,
        total: 0,
    };
    filterStatus = [
        { text: this.$t('common.enable'), value: 1 },
        { text: this.$t('common.disable'), value: -1 },
    ];
    filterTaskStatus = [
        { text: this.$t('status.abnormal'), value: 3 },
        { text: this.$t('status.effect'), value: 1 },
    ];
    initI18n() {
        this.filterStatus = [
            { text: this.$t('common.enable'), value: 1 },
            { text: this.$t('common.disable'), value: -1 },
        ];
        this.filterTaskStatus = [
            { text: this.$t('status.abnormal'), value: 3 },
            { text: this.$t('status.effect'), value: 1 },
            // { text: this.$t('status.noEffective'), value: 2 },
        ];
    }
    formatDate(row, column, cellValue, index) {
        const sDate = row.taskStartDate;
        const eDate = row.taskEndDate;
        let result = this.$t('perpetual');
        if (sDate && eDate) {
            result = `${sDate} ~ ${eDate}`;
        }
        else if (sDate) {
            result = `${sDate} ~ ${this.$t('indefinite')}`;
        }
        return result;
    }
    formatTime(row, column, cellValue, index) {
        const sDate = row.taskStartTime;
        const eDate = row.taskEndTime;
        let result = this.$t('allDay');
        if (sDate && eDate) {
            if (!(sDate === '00:00:00' && eDate === '23:59:59'))
                result = `${sDate} ~ ${eDate}`;
        }
        else if (sDate) {
            result = `${sDate} ~ 23:59:59`;
        }
        else if (eDate)
            result = `00:00:00 ~ ${eDate}`;
        return result;
    }
    filterStatusTag(value, row) {
        console.log(value, row);
        return row.taskStatus === value;
    }
    filterTaskStatusTag(value, row) {
        return row.taskRunStatus === value;
    }
    handleSelectionChange(val) {
        this.multipleSelection = val;
        this.multipleLength = this.multipleSelection.length;
    }
    toggleSelection() {
        this.multipleTable.clearSelection();
    }
    /**
     *@Description: 清空
     *@Date: 2020-09-10 18:19:59
     */
    handleClear(rows) {
        this.$refs.multipleTable.clearSelection();
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getTaskList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTaskList();
    }
    getTaskList() {
        this.loading = true;
        const reqParam = {
            taskTypes: [1],
            taskCategory: 'FACE',
            page: this.pagination.page,
            size: this.pagination.size,
            keyword: this.keyword,
        };
        getTaskList({ ...reqParam })
            .then(re => {
            this.loading = false;
            this.taskList = re.data.data.baseTaskVOList;
            this.taskList.map((res) => {
                let libraryNameList = '';
                let libraryIds = JSON.parse(res.configJson).libraryIds;
                libraryIds.forEach((library) => {
                    this.librariesAll.map((libraries) => {
                        if (library === libraries.libraryId) {
                            libraryNameList += libraries.libraryName + ',';
                        }
                    });
                });
                res.libraryNameList = libraryNameList.slice(0, -1);
            });
            this.pagination.total = re.data.data.totalSize;
        })
            .catch(error => {
            this.loading = false;
            console.log('error:', error);
        });
    }
    /**
     *@Description: 停用/启用
     *@Date: 2020-09-17 15:33:53
     */
    activeDevice(sid, status) {
        const respFunc = status === 1 ? disableTask : enableTask;
        // if(status===1){ // 停用设备
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmActive = status === 1 ? `${this.$t('device.confirmDisable')}` : `${this.$t('device.confirmActiveControl')}`;
        this.$elconfirm(deviceConfirmActive, `${this.$t('common.warning')}`, {
            confirmButtonText: confirm,
            type: 'warning',
            center: true,
            cancelButtonText: `${this.$t('common.no')}`,
            callback: action => {
                if (action === 'confirm') {
                    respFunc(sid)
                        .then(res => {
                        this.$message({ message: res.data.message, type: 'success' });
                        this.getTaskList();
                    })
                        .catch(err => {
                        this.$message({ message: err, type: 'error' });
                    });
                }
            },
        });
    }
    /**
     *@Description: 删除任务
     *@Date: 2020-09-17 10:08:01
     */
    handleDelete(sid) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('device.confirmDelete')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            confirmButtonText: confirm,
            type: 'warning',
            center: true,
            cancelButtonText: `${this.$t('common.no')}`,
            callback: action => {
                if (action === 'confirm') {
                    deleteTargetsDetail(sid).then(res => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.getTaskList();
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     *@Date: 2020-09-17 10:24:22
     */
    handleEdit(id) {
        this.$router.push(`/monitor/task/editfaceControl/${id}`);
    }
    created() {
        // this.getlibrariesAll();
    }
    mounted() {
        this.getTaskList();
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'TaskFaceControl',
        components: {
            AuthItem,
        },
        i18n: {
            messages: {
                zh: {
                    parameter: '参数',
                    perpetual: '永久',
                    indefinite: '无线期',
                    allDay: '全天',
                },
                'en-us': {
                    parameter: 'Metrics',
                    perpetual: 'forever',
                    indefinite: 'indefinite',
                    allDay: 'all day',
                },
            },
        },
    })
], default_1);
export default default_1;
